import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { IFooterTab, Tabs } from '../Tabs';
import { ADD_TEXT, DEFAULT_TAB, TABS, TAB_OVERLAYS, tabType } from '../constants';
import { usePickedImages } from '../../LeftWorkArea/LeftWorkUpload/usePickedImages';
import { AddText } from '../TextSubFooter/TextForm';

interface IMainFooter {
    tabSelection: (tab: tabType) => void,
    addToCart: (e: any) => void,
    cartEnabled: boolean
}

export const MainFooter = (props: IMainFooter) => {
    const { tabSelection, addToCart, cartEnabled } = props;

    const onImageLoaded = useCallback((success: boolean) => {
        success && tabSelection(DEFAULT_TAB)
    }, [])

    const onImageSelected = usePickedImages(onImageLoaded);

    const tabs: IFooterTab[] = [
        {
            imageSrc: "./assets/img/icons/size_icn.svg",
            title: TABS.SIZE.title,
            onClick: () => { tabSelection(TABS.SIZE) },
        },
        {
            imageSrc: "./assets/img/icons/color_icn.svg",
            title: TABS.COLOR.title,
            onClick: () => { tabSelection(TABS.COLOR) }
        },
        {
            imageSrc: "./assets/img/icons/image_icn.svg",
            title: TABS.IMAGE.title,
            onClick: (acceptedFiles: File[]) => {
                onImageSelected(acceptedFiles);
            },
            isPicker: true
        },
        {
            imageSrc: "./assets/img/icons/text_icn.svg",
            title: TABS.TEXT.title,
            onClick: () => { tabSelection(TAB_OVERLAYS.ADD_TEXT) }
        },
        {
            imageSrc: "./assets/img/icons/Add2Cart.svg",
            title: TABS.CART.title,
            highlight: true,
            disable: !cartEnabled,
            onClick: addToCart
        }
    ];

    return <Tabs mainTabItems={tabs} />
}